import {Component, HostListener} from '@angular/core';
import { LoginService } from "../services/auth/login.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-auto-logout-idle',
  templateUrl: './auto-logout-idle.component.html',
  styleUrls: ['./auto-logout-idle.component.css']
})
export class AutoLogoutIdleComponent {
  private idleTimeout: any;
  private idleTimeoutDuration = 60 * 60 * 1000;

  constructor(
    private authService: LoginService,
    private router: Router,
  ) { }

  ngOnInit() {
    if(this.router.url != '/'){
      this.resetIdleTimeout();
    }
  }

  @HostListener('document:mousemove') @HostListener('document:keypress')
  resetIdleTimeout() {
    clearTimeout(this.idleTimeout);
    this.idleTimeout = setTimeout(() => this.logout(), this.idleTimeoutDuration);
  }

  private logout() {
    this.authService.logout();
    localStorage.setItem('forcedLogoutAt', Date.now().toString());
  }
}
